/**
 * Input Schema of ResponsavelHistoricoSms
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelHistoricoSms} from '@/model/resource/ResponsavelHistoricoSms'
import {CargaCollection} from '@/model/collection/CargaCollection'
import {MotoristaCollection} from '@/model/collection/MotoristaCollection'
import {TypeSmsCollection} from '@/model/collection/TypeSmsCollection'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'

/* TODO: review generated schema */
export class InputResponsavelHistoricoSmsSchema extends Schema {
  collectionCarga = new CargaCollection().noPagination()
  collectionMotorista = new MotoristaCollection().noPagination()
  collectionTypeSms = new TypeSmsCollection().noPagination()
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'InputResponsavelHistoricoSms'

  readonly fieldSet: FieldSet<ResponsavelHistoricoSms> = {
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    motorista: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionMotorista.all(),
      },
    }),
    typeSms: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionTypeSms.all(),
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    nomeDestinatario: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    mensagem: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    dataEnvio: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    nfe: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 127,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    telefone: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'phone',
        label: this.translateFrom(schema.fieldName),
        validation: 'phone',
      },
    }),
  }
}
